type Props = {
  text?: string;
};

const DefaultContent = {
  text: `Es probable que Empresas Matco utilice tu información para futuras comunicaciones.
Puedes cancelar la recepción de estas comunicaciones en cualquier momento.
Para obtener más información revisa nuestra <a href="/politicas/politicas-de-privacidad" target="_blank" rel="noopener noreferrer" class="font-bold underline">Política de privacidad</a>.`,
};

const ContactUsComunication = ({ text }: Props) => {
  const content = text || DefaultContent.text;

  return (
    <div className="mt-16 bg-gray01 border border-gray02 p-6 text-sm">
      <p
        className="text-gray03"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default ContactUsComunication;